if (!customElements.get('dpe-sticky-purchase')) {
  customElements.define('dpe-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      this.purchase = document.getElementById(`DPEPurchase-${this.dataset.sectionId}`);
      this.sourcePrice = document.getElementById(`price-${this.dataset.sectionId}`);
      this.price = this.querySelector('.dpe-sticky-purchase__price');
      this.link = this.querySelector('a');
      if (!this.purchase || !this.link || !('IntersectionObserver' in window)) return;

      this.hidden = true;
      this.dataset.enhanced = 'true';

      this.visibilityObserver = new IntersectionObserver(([entry]) => {
        this.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      });
      this.visibilityObserver.observe(this.purchase);

      if (this.sourcePrice && this.price) {
        const syncPrice = () => {
          this.price.innerHTML = this.sourcePrice.innerHTML;
          this.price.hidden = this.sourcePrice.classList.contains('hidden');
        };
        this.priceObserver = new MutationObserver(syncPrice);
        this.priceObserver.observe(this.sourcePrice, { childList: true, subtree: true, attributes: true });
        syncPrice();
      }

      this.onNavigate = () => {
        this.hidden = true;
        this.purchase.focus({ preventScroll: true });
      };
      this.link.addEventListener('click', this.onNavigate);
    }

    disconnectedCallback() {
      this.visibilityObserver?.disconnect();
      this.priceObserver?.disconnect();
      this.link?.removeEventListener('click', this.onNavigate);
    }
  });
}
